import { FormFieldTypes } from "../FormFieldSelector/interfaces";
import { IToggleDynamicOptions } from "./interface";

export const dataVerifier = (fieldType: string, _data: any) => {
  switch (fieldType) {
    case FormFieldTypes.DROPDOWN:
      return dropdownDataVerifier(_data);
  }
};

export const dropdownDataVerifier = (_data: any) => {
  if (
    typeof _data !== "object" ||
    (typeof _data === "object" && !Array.isArray(_data))
  )
    return [];
  return _data.filter(
    (_dropdownData: { optionKey: string; optionValue: string }) =>
      _dropdownData.optionKey
  );
};

export const stringToExecutableFunction = (stringFunction: string) => {
  const myFunction = new Function(` return (${stringFunction}) `);
  return myFunction();
};

export const dynamicOptionsSetupInitialValue: IToggleDynamicOptions = {
  isValidated: false,
  checkValidation: false,
  ischecked: true,
  enableDynamicFetch: false,
  dynamicApiUri: "",
  dataConversionFunction: "",
};
